export default "__VITE_ASSET__Cs2Mn3u8__"